import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { useInstructorProfile } from '@/features/instructors/hooks/useInstructorProfile'
import { PageLoader } from '@/components/PageLoader'

interface AdminOrInstructorRouteProps {
  children: React.ReactNode
}

export function AdminOrInstructorRoute({ children }: AdminOrInstructorRouteProps) {
  const { user, isLoading: authLoading } = useAuth()
  const { data: instructorProfile, isLoading: profileLoading } = useInstructorProfile()
  const location = useLocation()

  // Wait for both auth and instructor profile to load
  if (authLoading || profileLoading) {
    return <PageLoader />
  }

  // Must be logged in
  if (!user) {
    const returnPath = location.pathname + location.search;
    return <Navigate to={`/login?from=${encodeURIComponent(returnPath)}`} replace />
  }

  // Must be either admin OR instructor
  const isAdmin = user.is_superuser
  const isInstructor = !!instructorProfile

  if (!isAdmin && !isInstructor) {
    return <Navigate to="/" state={{ from: location, error: 'Admin or instructor access required' }} replace />
  }

  return <>{children}</>
}
